<script>
import {mapGetters} from 'vuex'

export default {
    name: process.env.VUE_APP_NAME,

    computed: mapGetters([
        'siteLayout', 'siteTitle', 'siteDesc', 
        'siteImage', 'siteUrl', 'keywords'
    ]),

    metaInfo()
    {
        return {
            title: process.env.VUE_APP_TITLE,
            meta: [
                { vmid: 'description', name: 'description', content: this.siteDesc || process.env.VUE_APP_DESCRIPTION},
                { vmid: 'keywords', name: 'keywords', content: this.keywords || process.env.VUE_APP_KEYWORDS},
                { property: 'og:description',content: this.siteDesc || process.env.VUE_APP_DESCRIPTION, vmid: 'og:description'},
                { property: 'og:keywords',content: this.keywords || process.env.VUE_APP_KEYWORDS, vmid: 'og:keywords'},
                { property: 'og:image',content: this.siteImage || `${process.env.VUE_APP_FRONTEND_URL}/img/logo.png`, vmid: 'og:image'},
                { property: 'og:url',content: this.siteUrl || process.env.VUE_APP_FRONTEND_URL, vmid: 'og:url'},
            ],
            htmlAttrs: {
                lang: process.env.VUE_APP_LOCALE || 'en',
            }
        }
    },

    data()
    {
        return {
            loaded: false,
        }
    },

    mounted()
    {
        this.$store.dispatch('init').then(() => this.loaded = true)
    }
}
</script>


<template lang="pug">
    #app
        transition(name='page')
            component(v-if="loaded && siteLayout" :is="siteLayout")
</template>
